import { z } from 'zod';
import { envelope, IdString } from './common.js';

export const Permission = z.enum([
  'acct.read',
  'acct.recon.run',
  'acct.exception.resolve',
  'acct.export',
  'acct.rule.approve',
  'acct.admin',
]);
export type Permission = z.infer<typeof Permission>;

/** Vai trò gán theo công ty (tenant), có thể giới hạn một pháp nhân. */
export const Role = z.enum(['viewer', 'accountant', 'chief_accountant', 'admin']);
export type Role = z.infer<typeof Role>;

export const ROLE_PERMISSIONS: Record<Role, readonly Permission[]> = {
  /** Chỉ xem và xuất file; không chạy đối soát, không đóng ngoại lệ, không kết nối shop. */
  viewer: ['acct.read', 'acct.export'],
  accountant: ['acct.read', 'acct.export', 'acct.recon.run', 'acct.exception.resolve'],
  chief_accountant: ['acct.read', 'acct.export', 'acct.recon.run', 'acct.exception.resolve', 'acct.rule.approve'],
  admin: Permission.options,
};

export const ROLE_LABEL: Record<Role, string> = {
  viewer: 'Xem',
  accountant: 'Kế toán',
  chief_accountant: 'Kế toán trưởng',
  admin: 'Quản trị',
};

/** Claim trong JWT dev (chỉ NODE_ENV=development): danh sách tenant và quyền. */
export const SessionClaims = z.object({
  sub: z.string().min(1),
  name: z.string().optional(),
  tids: z.array(IdString).min(1).max(200),
  perms: z.array(Permission).default([]),
});
export type SessionClaims = z.infer<typeof SessionClaims>;

export const LoginRequest = z.object({
  email: z.string().trim().toLowerCase().email('Email không hợp lệ').max(254),
  password: z.string().min(1, 'Nhập mật khẩu').max(256),
});
export type LoginRequest = z.infer<typeof LoginRequest>;

export const Grant = z.object({
  tenantId: IdString,
  legalEntityId: IdString.nullable(),
  role: Role,
  permissions: z.array(Permission),
});
export type Grant = z.infer<typeof Grant>;

export const Me = z.object({
  user: z.object({ id: z.string(), email: z.string(), name: z.string().nullable() }),
  grants: z.array(Grant),
  /** Phiên dev bằng JWT (chỉ có ở môi trường phát triển). */
  dev: z.boolean().default(false),
});
export type Me = z.infer<typeof Me>;

export const MeResponse = envelope(Me);
export type MeResponse = z.infer<typeof MeResponse>;

/** Header bắt buộc cho mọi request ghi (POST/PUT/PATCH/DELETE): chặn CSRF từ form trang khác. */
export const CSRF_HEADER = 'x-requested-with';
export const CSRF_VALUE = 'serievo';
